import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpUserEvent,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { TokenService } from 'services/token/token-service.service';
import { ConfigService } from 'services/config/config.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private tokenService: TokenService,
    private configService: ConfigService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | HttpEvent<any>> {
    const getRequest = () => {
      return request.clone({ headers: new HttpHeaders({ 'Authorization': this.tokenService.getIdToken()}) })
    }

    return next.handle(request)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.url.includes(this.configService.getConfig().apiUrl) && err.status === 403 && err.error.message === "invalidToken" && !err.url.includes('api/token/refresh')) {
            return this.tokenService.checkToken().pipe(mergeMap((success) => {
              return success ? next.handle(getRequest()) : throwError(err);
            }));
          }
          return throwError(err);
        })
      )
  }
}
